import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import Textblock from '../../../../components/textblock'
import { Column, Row } from '../../../../components/layout-row'
import DoodleBackground from '../../../../components/doodle-background'

import imgBooking from './booking-border.png'
import imgTodo from './todo-border.png'
import imgVat from './vat-border.png'

import styles from './features.module.scss'

const Features = () => (
  <div className={styles.root}>
    <DoodleBackground variant="bottomRight" />

    <Row id="feature-one">
      <Column first limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="Du ska inte behöva vara ekonom för att sköta din bokföring, Dooer är därför helt anpassat och utvecklat för dig som företagare. Med allt för att göra din vardag enklare."
              id="diy-accounting.features.1-description"
            />
          }
          subTitle={<FormattedMessage defaultMessage="Smidigare vardag" id="diy-accounting.features.1-subtitle" />}
          title={<FormattedMessage defaultMessage="Mjukvara med dig i fokus" id="diy-accounting.features.1-title" />}
          variant="free"
        />
      </Column>

      <Column>
        <img alt="Dooer bokför" src={imgBooking} />
      </Column>
    </Row>

    <Row id="feature-two" top="second">
      <Column className={styles.extraWide} first>
        <img alt="Dooer momsdeklarera" src={imgVat} />
      </Column>

      <Column className={styles.extraSmall} limitWidth>
        <Textblock
          description={
            <FormattedHTMLMessage
              defaultMessage="Genom våra smarta integrationer till Skatteverket och bank synkas dina transaktioner direkt till bokföringen och du rapporterar till Skatteverket på några klick, direkt i Dooer."
              id="diy-accounting.features.2-description"
            />
          }
          subTitle={<FormattedMessage defaultMessage="Smartare företagande" id="diy-accounting.features.2-subtitle" />}
          title={
            <FormattedMessage defaultMessage="Allt du behöver i ett program" id="diy-accounting.features.2-title" />
          }
          variant="free"
        />
      </Column>
    </Row>

    <Row id="feature-three">
      <Column className={styles.extraSmall} first limitWidth>
        <Textblock
          description={
            <FormattedHTMLMessage
              defaultMessage="Med tydliga guider och en smart att-göra-lista har vi gjort det komplicerade enkelt. Du får hela tiden reda på vad du behöver göra nu och viktiga datum som kommer."
              id="diy-accounting.features.3-description"
            />
          }
          subTitle={<FormattedMessage defaultMessage="Säkrare bokföring" id="diy-accounting.features.3-subtitle" />}
          title={<FormattedMessage defaultMessage="Smarta guider hjälper dig" id="diy-accounting.features.3-title" />}
          variant="free"
        />
      </Column>
      <Column className={styles.extraWide}>
        <img alt="Dooer todo" src={imgTodo} />
      </Column>
    </Row>
  </div>
)

export default Features
